import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';

export const templateNoteEditor = document.createElement('template');

templateNoteEditor.innerHTML = `
  <style>${colorHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper" part="wrapper">
     <div class="note-editor-container edit-container" part="edit-container">
             <gz-text fontSize="12" class="title" id="noteTitle"></gz-text>
             <gz-textarea class="notes-panel-textarea" id="notesPanelTextarea" hasCounter="true" maxChars="2048" rows="6"></gz-textarea>
           <div class="button-container">
               <gz-button class="notes-panel-save-note" id="saveButton" disabled="true"></gz-button>
               <gz-button class="notes-panel-cancel-note" id="cancelButton" type="outline" color="secondary"></gz-button>
          </div>
     </div>
     <div class="discard-note-container" part="discard-container">
             <gz-title fontSize="18" class="discard-title" fontWeight="500" id="discardTitle"></gz-title>
             <gz-text fontSize="14" class="discard-description" id="discardDescription"></gz-text>
           <div class="button-container">
               <gz-button class="notes-panel-save-note" id="discardButton" type="outline" color="negative"></gz-button>
               <gz-button class="notes-panel-cancel-note" id="discardCancelButton" type="outline" color="secondary"></gz-button>
          </div>
     </div>
          <div class="delete-note-container" part="delete-container">
             <gz-title fontSize="18" class="delete-title" id="deleteTitle" fontWeight="500"></gz-title>
             <gz-text fontSize="14" class="delete-description" id="deleteDescription"></gz-text>
           <div class="button-container">
               <gz-button class="notes-panel-save-note" id="deleteButton" type="outline" color="negative"></gz-button>
               <gz-button class="notes-panel-cancel-note" id="cancelButtonFromDeletePanel" type="outline" color="secondary"></gz-button>
          </div>
     </div>
  </div>
`;
